// removed by extract-text-webpack-plugin
module.exports = {"container":"RightSectionTicket__container__7BdHk"};


//////////////////
// WEBPACK FOOTER
// ./src/Containers/RightSectionTicket/RightSectionTicket.css
// module id = 533
// module chunks = 0